export default __webpack_public_path__ + "static/media/cubeia_logo.aa559c70.png";